import(/* webpackMode: "eager" */ "/codebuild/output/src3508424008/src/medh-web/src/app/courses/page.tsx");
